module.exports = __webpack_public_path__ + "img/icon_left_out.bf29e70f.svg";